import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { EmailCollectionTrayComponent } from './email-collection-tray.component';
import { PageContainerModule } from '@zelis/platform-ui-components';
import { ReactiveFormsModule } from '@angular/forms';
import { GtmModule } from '../../directives/gtm/gtm.module';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { UnfocusModule } from '@directives/unfocus/unfocus.module';
import { DlsIconModule } from '@zelis/dls/icons';
import { DlsButtonModule } from '@zelis/dls/button';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    FlexLayoutModule,
    PageContainerModule,
    ReactiveFormsModule,
    GtmModule,
    MatInputModule,
    MatFormFieldModule,
    UnfocusModule,
    DlsIconModule,
    DlsButtonModule,
  ],
  declarations: [EmailCollectionTrayComponent],
  exports: [EmailCollectionTrayComponent],
})
export class EmailCollectionTrayModule {}
